<template>
  <div>
    <div v-if="conf.bpmConfig && conf.bpmConfig.statisticsTmp && conf.bpmConfig.statisticsTmp.interfaceReturns && conf.bpmConfig.statisticsTmp.interfaceReturns.length > 1">
      <myTable
        ref="myTable"
        class="myTable"
        :is-show-border="false"
        :table-data="tableData"
        :table-columns="tableTitle"
        :table-loading="loading"
      />
    </div>
    <div v-else-if="!value">--</div>
    <div v-else-if="typeof value === 'string'">{{ value }}</div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'MyStatistics',
  props: {
    // 组件的值
    value: {
      type: [String, Object, Array],
      default: null
    },
    // 选中的模板
    statisticsTmp: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 筛选字段
    filterFields: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 整个表单的数据
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 计算公式配置
    conf: {
      type: Object,
      default: () => {}
    },
    isInTemplate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      page: {
        pageSize: 10,
        pageNum: 1
      },
      total: 5
    }
  },
  computed: {
    // 过滤出需要监听的组件
    formDataFilter() {
      const obj = {}
      Object.keys(this.formData).forEach(key => {
        if (this.filterFields.map(item => {
          return item.formField
        }).includes(key)) {
          obj[key] = this.formData[key]
        }
      })
      return obj
    },
    tableTitle() {
      const tableColumns = []
      const colnums = this?.conf?.bpmConfig?.statisticsTmp?.interfaceReturns || []
      console.log('colnums', colnums)
      if (colnums instanceof Object) {
        colnums.forEach((item) => {
          tableColumns.push({
            label: item.returnValueName,
            prop: item.returnValueNameEn,
            showTooltip: true
          })
        })
      }
      return tableColumns
    }
  },
  watch: {
    // 监听模板的变化
    statisticsTmp: {
      handler(val) {
        this.getResult()
      }
    },
    // 监听组件值的变化
    formDataFilter: {
      handler(val) {
        this.getResult()
      },
      deep: true,
      immediate: true
    },
    value: {
      handler(val) {
        if (val instanceof Object) {
          this.tableData = val
        }
      },
      immediate: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    async getResult() {
      if (this.isInTemplate) return
      // 第一步：获取发送请求的所有入参
      const params = {}
      this.statisticsTmp.variables?.forEach(item => {
        params[item.variableNameEn] = null
      })
      // 第二步：将过滤规则中配置的入参与表单值绑定
      this.filterFields.forEach(item => {
        if (Object.keys(this.formData).includes(item.formField)) {
          params[item.filterCondition] = this.formData[item.formField]
        }
      })
      // console.log(params, '====params')
      // 第三步：发送请求，传递查询结果
      if (Object.keys(this.statisticsTmp).length) {
        let result = null
        if (this.statisticsTmp.requestMethodStr.toLowerCase() === 'post') {
          const { data } = await axios({
            url: this.statisticsTmp.interfacePath,
            // url: 'http://192.168.156.45:8080/interface_info/test/list',
            method: this.statisticsTmp.requestMethodStr,
            data: params
          })
          if (data.code === 200 && data.data) {
            result = data.data
          } else {
            result = null
          }
          this.$emit('input', result)
        } else if (this.statisticsTmp.requestMethodStr.toLowerCase() === 'get') {
          const { data } = await axios({
            url: this.statisticsTmp.interfacePath,
            method: this.statisticsTmp.requestMethodStr,
            params
          })
          if (data.code === 200 && data.data) {
            result = data.data
          } else {
            result = null
          }
          this.$emit('input', result)
        }
      } else {
        // 没有配置模板时，统计结果为null
        this.$emit('input', null)
      }
      // 第四步：根据不同的接口返回值做不同的页面展示
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
